exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".initcolor[data-v-2505ba2a] {\n  color: #0000FF;\n}\n.ingcolor[data-v-2505ba2a] {\n  color: #009588;\n}\n.errorcolor[data-v-2505ba2a] {\n  color: #D9001B;\n}\n.passcolor[data-v-2505ba2a] {\n  color: #000000;\n}\n", ""]);

// exports
